module.exports = __webpack_public_path__ + "CPostit.svg?117db1f42a2fd8599dfb60da7021ba8f";